module.exports = __webpack_public_path__ + "static/media/lo_zomerlinde.99604838.svg";